import { Component, OnInit, OnDestroy } from '@angular/core';
import { BoardConfigService, UserService, FamilyService, FormConfigService } from '@app/services';
import { PermissionService } from '@app/services/permission.service';
import { Router } from '@angular/router';
import { Adulte } from '@app/models/adulte';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { StepType } from '@app/forms/config/form-model';
import { AdresseUpdateService } from '@app/services/adresse-update.service';

@Component({
  selector: 'app-foyer',
  templateUrl: './foyer.component.html',
  styleUrls: ['./foyer.component.scss']
})
export class FoyerComponent implements OnInit, OnDestroy {

  // Data
  userData: Adulte;
  infosFoyer: any;
  conjoint: Adulte; // {};
  id: number;

  // Step names (for button DropDown)
  adulteFormSteps: any[];
  foyerFormSteps: any[];
  listKeysFieldForm: any[] = [];

  // Permission
  editFoyer: boolean;

  onDestroy$ = new Subject();

  constructor(
    private router: Router,
    private familyService: FamilyService,
    private formConfigService: FormConfigService,
    private userService: UserService,
    private permService: PermissionService,
    private addressService: AdresseUpdateService,
  ) { }

  ngOnInit() {
    this.editFoyer = this.permService.getPermissionSettings().foyer_edit && this.familyService.currentFamily.active;
    this.id = (this.familyService.currentFamily ? this.familyService.currentFamily.id : null) || null;

    this.loadForms();
    this.loadUserData();

    // Update family data every time user switches family
    this.familyService.currentFamily$.pipe(
      filter(f => !!f),
      takeUntil(this.onDestroy$)
    ).subscribe(f => this.reloadFoyerData(f.id));


    this.addressService.clickToUpdateAddress$.pipe(
      takeUntil(this.onDestroy$)
    ).subscribe(value => {
      if (value === true) {
        this.loadForms();
        this.loadUserData();
        this.reloadFoyerData(this.id);
      }
    })
  }

  loadUserData() {
    this.userService.getCurrentUserData().subscribe(data => this.userData = data);
  }

  reloadFoyerData(id: number) {
    this.infosFoyer = null;
    this.conjoint = null;

    this.familyService.getFamilyData(id).subscribe(data => {
      this.infosFoyer = data.famille;
      this.conjoint = data.conjoint;
    });
  }

  loadForms() {
    this.formConfigService.getForm('form-famille').subscribe(form => {
      this.foyerFormSteps = this.getFormattedSteps(form, ['validation']);
      this.listKeysFieldForm = this.formConfigService.getKeysListOfFormSteps(form);
    });
    this.formConfigService.getForm('form-adulte').subscribe(form => this.adulteFormSteps = this.getFormattedSteps(form, ['validation']));
  }

  getFormattedSteps(steps: StepType[], excludedNames: string[]) {
    return steps
      .filter(step => !excludedNames || !excludedNames.includes(step.stepName))
      .map(step => ({ stepName: step.stepName, label: step.label }));
  }

  openForm(entityFormPath, stepName) {
    const path = stepName ? `/account/${entityFormPath}/${stepName}` : `/account/${entityFormPath}/edit`;
    this.router.navigate([path]);
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
